module.exports = __webpack_public_path__ + "static/img/bank-icon.039a55d4.png";